import { AddProductMagentoResponse, Product } from '../../cart/shop-cart/interfaces/shop-cart.interface';
import { mhecommLocalStorage } from '../../../common/local-storage';

const REPLACED_FREE_TRIAL = 'replacedFreeTrial';

/**
 * Marks the free trial as replaced (e.g. the duration has changed).
 *
 * @param response
 */
export function markReplacedProduct(response?: AddProductMagentoResponse): void {
  if (response?.sku && response?.extension_attributes?.free_trial_replaced == true) {
    mhecommLocalStorage.set(REPLACED_FREE_TRIAL, response?.sku, 1);
  }
}

/**
 * Returns true if the free trial was replaced.
 *
 * @param product
 */
export function wasFreeTrialReplaced(product: Product): boolean {
  const replacedSku = mhecommLocalStorage.get(REPLACED_FREE_TRIAL);
  if (!replacedSku) {
    return false;
  }

  return product.productIdentifier?.sku === replacedSku;
}

/**
 * Clears the free trial replaced flag from the local storage.
 */
export function cleanFreeTrialReplacedFlag(): void {
  mhecommLocalStorage.remove(REPLACED_FREE_TRIAL);
}
